import { apiProxyRequest } from "Api/apiProxyRequest";

import type { OrganizationAddress } from "./types";

export const updateOrganizationAddressRequest = (
  organizationId: string,
  updates: Partial<OrganizationAddress>
) =>
  apiProxyRequest<OrganizationAddress>(
    `/organizations/${organizationId}/address`,
    "PATCH",
    updates
  );
